module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_core-js@2.6.2@core-js/library/modules/_add-to-unscopables.js
// module id = 462
// module chunks = 0